import { Dispatch } from 'redux'

import { create, destroy, getAll } from 'redux/api/CredentialsGroups'
import { useThunkActions } from 'redux/actions/useThunkActions'

import * as actions from './actions'

function tryGetAllCredentialsGroups() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll())

    getAll()
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

function tryCreateCredentialsGroups(body: { title: string; labels: string[] }) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    create(body)
      .then((response) => {
        dispatch(actions.createSuccess(response.data))
      })
      .catch(() => {
        dispatch(actions.createFailed())
      })
  }
}

function tryDeleteCredentialsGroups(id: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    destroy(id)
      .then(() => {
        dispatch(actions.destroySuccess(id))
      })
      .catch(() => {
        dispatch(actions.destroyFailed())
      })
  }
}

export const useCredentialsGroupsActions = () => {
  return {
    tryGetAllCredentialsGroups: useThunkActions(tryGetAllCredentialsGroups),
    tryCreateCredentialsGroups: useThunkActions(tryCreateCredentialsGroups),
    tryDeleteCredentialsGroups: useThunkActions(tryDeleteCredentialsGroups)
  }
}
